<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-layer-group', fontSet: 'fad'}"
	[headerText]="'Exam Phases'"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<div class="phaseWrapper">
			@for (phase of activePhases; track Number(phase.type)) {
				<mat-expansion-panel #phasePanel (opened)="collapseOtherPhases(phasePanel.id)">
					<!--PANEL HEADER-->
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ phase.type | enumLabel: EnumLabel.SessionPhase }}
						</mat-panel-title>
						<div class="phaseColor {{ PhaseColorMapping[phase.type] }}"></div>
					</mat-expansion-panel-header>

					<!--DESC PARAGRAPH-->
					<div class="description">
						<span class="duration">
							<mat-icon fontIcon="fa-stopwatch" fontSet="fad" />
							{{ phase.durationInSeconds * 1000 | durationLabel }} {{ T.LABEL_MINUTES | translate }}
						</span>
					</div>

					<!--ANNOUNCEMENTS-->
					@for (scheduledSound of phase.scheduledSounds; track scheduledSound.mediaId) {
						@if ($first) {
							<mat-divider />
						}
						<div class="soundWrapper">
							<label>
								<mat-icon fontIcon="fa-volume" fontSet="fad" />
								<span>{{ scheduledSound.name }}</span>
							</label>
							<label>
								<mat-icon fontIcon="fa-alarm-clock" fontSet="fad" />
								<span>at {{ scheduledSound.offset | durationLabel }} min</span>
							</label>
						</div>
						<mat-divider />
					}
				</mat-expansion-panel>
			}
		</div>
	</ng-container>
	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontIcon: 'fa-check', fontSet: 'fas'}" [label]="T.BUTTON_CLOSE" />
	</ng-container>
</sim-basic-material-dialog>
